import { fromJS, Record } from 'immutable';
import { TrackingObjectNamesEnum } from '../tracking.data';
import { ITrackingObject } from 'i2g-ng-tracking';
import { generateKeys, generateSchema } from 'i2g-ng-utils';

export interface IAccountTrackingObjectData {
  email?: string;
  accountId?: string;
  i2gUserId?: string;
}

export const TRACKING_SETTINGS_SCHEMA = Object.freeze({
  EMAIL: '',
  ACCOUNT_ID: '',
  I2G_USER_ID: '',
});
const RECORD = generateSchema(TRACKING_SETTINGS_SCHEMA);
const KEYS: any = generateKeys(TRACKING_SETTINGS_SCHEMA);

export class AccountTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.account;
  }

  get properties() {
    return this.toJS();
  }
}
